import { isProductEnabled } from "@/business/product-access";
import { USER_ROLES } from "./constants";

export const roleAccessDescription = (role: string, settings: unknown) => {
  const payroll = isProductEnabled(settings, "payroll");
  const referrals = isProductEnabled(settings, "referrals");
  const ap = isProductEnabled(settings, "accounts_payable");
  const profitability = isProductEnabled(settings, "profitability");
  switch (role) {
    case USER_ROLES.ADMIN:
      return "Full access to all Volca features.";
    case USER_ROLES.OWNER:
      return [
        payroll
          ? "Manage users with full workbook access. Payroll access is assigned separately."
          : "Manage user accounts.",
        ap ? "Manage Accounts Payable." : "",
        profitability ? "Use Job Costing reports." : "",
        referrals ? "Manage referrals, payouts, and wallet transfers." : "",
      ]
        .filter(Boolean)
        .join(" ");
    case USER_ROLES.MANAGER:
      return [
        "Cannot manage user accounts.",
        payroll ? "Payroll access is assigned separately." : "",
        ap ? "Use Accounts Payable." : "",
        referrals
          ? "Manage referrals and payouts, without wallet transfers."
          : "",
      ]
        .filter(Boolean)
        .join(" ");
    case USER_ROLES.REP:
      return [
        "Cannot manage user accounts.",
        referrals
          ? "Manage referrals and advocates, without payouts or wallet transfers."
          : "",
        payroll ? "Workbook access is assigned separately." : "",
      ]
        .filter(Boolean)
        .join(" ");
    case USER_ROLES.TECH:
      return [
        payroll ? "View your own pay statements when available." : "",
        referrals ? "View your referral code, QR code, and leaderboard." : "",
        "Cannot manage user accounts.",
      ]
        .filter(Boolean)
        .join(" ");
    case USER_ROLES.AP_ONLY:
      return ap
        ? "Use Accounts Payable and your own profile. Cannot manage user accounts or use other products."
        : "Use your own profile until Accounts Payable is enabled. Cannot manage user accounts or use other products.";
    default:
      return "";
  }
};
